module.exports = __webpack_public_path__ + "img/nu.4388f2f8.svg";